import { useEffect, useState } from 'react';
// import parse from 'html-react-parser';
import { CacheProvider } from '@emotion/react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { convertEpochTime, getMUICache, getUrl, getImageId, getImageUrl, showMultipleAuthor, getImageSize, processArticleBody_New, getEndpoint, setCmsSeoData, isLoggedIn, getImageCreditString, isCSR, getAuthorCardTwo } from '../../../common/utils';
import { SocialShareTwo } from '../SocialShareTwo/SocialShareTwo';
import Tag from "../../Tag/Tag";
import './ArticleShowTwo.css';
import { PAGEBUILDER_URLS, URL_PROTOCAL } from '../../Common/Constant';
import bcrypt from 'bcryptjs-react';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';
// import { AuthorShowTwo } from '../AuthorShowTwo/AuthorShowTwo';
// import { isMobile, isDesktop } from "react-device-detect";

ArticleShowTwo.version = 1000;

ArticleShowTwo.lang = 'en';
ArticleShowTwo.langs = [
    'en'
];
ArticleShowTwo.setLang = (lang: any) => {
    ArticleShowTwo.lang = lang;
}


Object.defineProperty(ArticleShowTwo, 'name', {
    writable: true,
    value: 'ArticleShowTwo'
});

export function ArticleShowTwo(props: any) {

    const { anchorLinksValue, showImageCredits, authorCard, showRelatedStories, imagecroptype, relatedStoriesLable } = props;
      // This log will help confirm if the value is coming from the page builder or using the default.
    // console.log(`ArticleShowTwo is using imagecroptype: ${imagecroptype}. (Prop was: ${props.imagecroptype})`);

    AddImageDimensions();
    SetHighPriorityImages();
    PreloadViewportImages();
    ImageLoader();
    useEffect(() => {
        EagerLoadImages()
    }, []);

    let [allData, setAllData] = useState<any>({});
    let [articleData, setArticleData] = useState<any>({});
    const [authorData, setAuthorData] = useState<any>([]);
    const [heroImageData, setHeroImageData] = useState<any>({});
    // const [visible, setVisible] = useState<any>(false);
    const [tagsData, setTagsData] = useState<any>([]);
    // let [embeds, setEmbeds] = useState<any>([]);
    // let [cmsembeds, setCmsembeds] = useState<any>([]);

    // let [cmsassocs, setCmsassocs] = useState<any>([]);
    const [agency, setAgency] = useState<any>('');
    const [starKeyword, setStarKeyword] = useState<any>("");
    // let [slideShows, setSlideShows] = useState<any>([]);
    const [completeBody, setCompleteBody] = useState<any>({});
    // let [contributionType, setContributionType] = useState<any>({});

    const endpoint = getEndpoint(props);
    const { showViewport } = props;

    let REQUEST_HOSTNAME: any = null;
    if (props && props.REQUEST_HOSTNAME) {
        REQUEST_HOSTNAME = props.REQUEST_HOSTNAME;
    }

    let REQUEST_URL: any = null;
    if (props && props.REQUEST_URL) {
        REQUEST_URL = props.REQUEST_URL;
    }

    // useEffect(() => {
    //     if (clientDevice.isDesktop && props.bodyAdScript) {
    //         const adContainer = document.getElementById("ad-container");
    //         if (adContainer) {
    //             const script = document.createElement("script");
    //             script.async = true;
    //             script.innerHTML = props.bodyAdScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
    //             adContainer.appendChild(script);
    //         }
    //     }
    //     if (clientDevice.isMobile && props.bodyAdMobileScript) {
    //         const adContainer = document.getElementById("ad-container");
    //         if (adContainer) {
    //             const script = document.createElement("script");
    //             script.async = true;
    //             script.innerHTML = props.bodyAdMobileScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
    //             adContainer.appendChild(script);
    //         }
    //     }
    // }, [clientDevice.isDesktop,clientDevice.isMobile, props.bodyAdScript, props.bodyAdMobileScript]);

    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
        if (allData && allData.it && allData.it.primeId) {
            isLoggedIn();
        }

        if (typeof window !== 'undefined' && window.gpEditor) {

            window.gpEditor.editor.on('component:selected', (component: any) => {
                if (component && component.attributes && component.attributes.type === "Article Show Two") {
                    setTimeout(() => {
                        const trait = component.getTraits().find((tr: any) => tr.get('id') === "deviceType");
                        if (trait && trait.el) {
                            // Show trait element if showAdSlot is true, hide otherwise
                            trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                        }
                    }, 200);
                }
            });

            const selected = window.gpEditor.getSelected();
            if (selected) {
                const trait = selected.getTraits().find((tr: any) => tr.get('id') === "deviceType");
                if (trait && trait.el) {
                    // Show trait element if showAdSlot is true, hide otherwise
                    trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                }
            }
        }

    }, [endpoint, props.showAdSlot, props.adSize, authorCard]);


    const setResponseOfAPI = (response: any) => {
        if (response && Object.keys(response).length > 0 && response.it && response.it != null) {
            if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.pid !== "undefined"
                && response.it.folderId != null && response.it.folderId != "") {
                props.exportedKeys.pid = response.it.folderId;
            }
            if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.sectionid !== "undefined"
                && response.it.id != null && response.it.id != "") {
                props.exportedKeys.sectionid = response.it.id;
            }
            if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.authorid !== "undefined"
                && typeof response.it.authors != "undefined" && response.it.authors.length > 0) {
                props.exportedKeys.authorid = response.it.authors[0].id;
            }
            if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.tags !== "undefined"
                && typeof response.it.kws != "undefined" && response?.it?.kws?.length > 0) {
                const names = response.it.kws.map((item: any) => item.name).join(',');
                props.exportedKeys.tags = names;
            }
            setAllData(response);
            allData = response;
            let obj = {
                title: response.it.hl,
                permaLink: response.it.wu,
                summary: response.it.syn,
                tags: response.it.metaKws,
                body: response.it.processStory,
                publishedDate: response.it.published,
                updatedDate: response.it.updated,
                baseDomain: response.it.pubInfo?.baseDomain,
                // highlights: response.it.highlights,
                highlights: processArticleBody_New(response.it.highlights, [], '', {}, '', '', '', '', false),
                authors: response.it.authors,
                authorDetails: response.it.authorDetails,
                relatedStories: response.it.cls
            };
            setCmsSeoData(props, response, "ArticleShow");
            setArticleData(obj);
            articleData = obj;
            setAuthorData(response.it.authors);

            if (response.it.cls && Array.isArray(response.it.kws) && response.it.kws.length > 0) {
                setStarKeyword(
                    (response.it.kws as { name: string; weightage: string }[])
                        .find((e) => e.weightage === "100")?.name || ""
                );
            }

            //  setContributionType(response.it.contribution);
            setAgency(response.it.ag);

            let imageIdObj = response?.it?.imageid;
            if (props.hostImageId && (!imageIdObj || !(imageIdObj.includes('imagesize=') || imageIdObj.includes('imgsize='))) ) {
                imageIdObj = props.hostImageId;
            }

            let heroImageData = {
                alt: response?.it?.metaInfo && response?.it?.metaInfo?.TitleOfTheImage,
                msid: getImageId(imageIdObj),
                imageCreditTxt: response?.it?.metaKews?.AgencyOfTheImage,
                imageAgency: response?.it?.metaKews?.TheCaptionOfTheImage,
                imageSize: getImageSize(imageIdObj),
                imageUrl: getImageUrl(getImageId(imageIdObj), getImageSize(imageIdObj), 616, undefined, response.it.pubInfo.baseDomain, false, props.CONSTANTS, imagecroptype || "4"),
                imageMetaTitle: response?.it?.metaInfo && response?.it?.metaInfo?.TitleOfTheImage,
                imageMetaAuthor: response?.it?.metaInfo && response?.it?.metaInfo?.PhotographerByline,
                imageMetaAgency: response?.it?.metaInfo && response?.it?.metaInfo?.AgencyOfTheImage,
                imageSourceName: response?.it?.metaInfo && response?.it?.metaInfo?.ImageCreditSourceName
            }

            setHeroImageData(heroImageData);
            heroImageData = heroImageData;

            setTagsData(response.it.kws);

            const embeds = response.it.embeds
            const cmsembeds = response.it.cmsembed

            let bodySnippet: any = '';
            if (props.showAdSlot) {
                if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
                    bodySnippet = ''
                    setCompleteBody({ articleBody: obj.body, embeds, cmsembeds, baseDomain: obj.baseDomain, CONSTANTS: props.CONSTANTS, bodySnippet, adSize: props.adSize, relatedStories: obj.relatedStories });

                }
                else if (isCSR()) {
                    console.log("Only CSR");
                    bodySnippet = props.data?.attributes?.adConfigurations
                    setCompleteBody({ articleBody: articleData.body, embeds, cmsembeds, baseDomain: articleData.baseDomain, CONSTANTS: props.CONSTANTS, bodySnippet, adSize: props.adSize, relatedStories: obj?.relatedStories });

                }
                else {
                    console.log("Only SSR");
                    bodySnippet = `<div></div>`;
                }
            }
            setCompleteBody({ articleBody: articleData.body, embeds, cmsembeds, baseDomain: obj.baseDomain, CONSTANTS: props.CONSTANTS, bodySnippet, adSize: props.adSize, relatedStories: obj?.relatedStories });
        }
    }


    if (endpoint.isSSR && endpoint.SSRDataObj && allData && Object.keys(allData).length === 0) {
        setResponseOfAPI(endpoint.SSRDataObj);
    }

    const fetchComponentData = () => {
        getData(getUrl(props, 1, false, 'MAIN', true));
    }

    const getData = (url: any) => {
        ////console.log("Articleshow URL ::: " + url)

        let headerString = '?' + url.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        fetch(url, { headers: headers })
            .then((response) => response.json())
            .then(response => {
                setResponseOfAPI(response);
            })
            .catch(err => {
                //console.log("Exception => ", err);
            });
    }

    const showCredits = () => {
        let creditComponent = []
        const authorContent = showMultipleAuthor(authorData, allData?.it?.pubInfo.baseDomain)

        if (props.showAuthor && authorContent.length != 0) {
            creditComponent.push(authorContent)
        }
        if (props.showNewsAgency && agency && agency.length != 0) {
            creditComponent.push(agency)
        }
        let formattedDate = '';
        if (props.GLOBAL_DATA_COMPONENT && props.GLOBAL_DATA_COMPONENT?.dateTimeFormat && props.GLOBAL_DATA_COMPONENT?.publishedOrUpdated && articleData && Object.keys(articleData).length != 0) {
            if (props.GLOBAL_DATA_COMPONENT.publishedOrUpdated === 'updated') {
                formattedDate = convertEpochTime(articleData.updatedDate, '', props.GLOBAL_DATA_COMPONENT.dateTimeFormat) as string;
            } else if (props.GLOBAL_DATA_COMPONENT.publishedOrUpdated === 'published') {
                formattedDate = convertEpochTime(articleData.publishedDate, '', props.GLOBAL_DATA_COMPONENT.dateTimeFormat) as string;
            }
        }

        if (formattedDate && props.showDateTime) {
            creditComponent.push(formattedDate)
        }
        let creditStr = creditComponent.join(" | ")
        return <><span className='articalShowAuthr' dangerouslySetInnerHTML={{ __html: creditStr }} /></>
    }
    
    const getRenderPart = () => {
        return (
            <CacheProvider value={getMUICache()}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid spacing={2}>
                        <Grid item md={12} className='themeTwoArticalShowWrapper'>
                            <div className='story-wrapper'>
                                <div className="card-box header-box">
                                    <div className='themeTwoArticalShowHeadingWrapper'>
                                        {/* <h1 className="themeTwoArticalShowHeading">
                                            {articleData?.title}
                                            dangerouslySetInnerHTML={{__html: articleData?.title}}
                                        </h1> */}
                                        <h1 className="themeTwoArticalShowHeading" dangerouslySetInnerHTML={{ __html: articleData?.title }}></h1>
                                    </div>
                                    <Grid container direction='row'>
                                        <Grid item xs={12}>
                                            <div className='themeTwoArticalAuthorWrapd2'>
                                                {showCredits()}
                                            </div>
                                        </Grid>
                                    </Grid>

                                </div>
                                <div className='themeTwoArticalShowSocialWrap articalShowMobileSocial'>
                                    <SocialShareTwo
                                        shareUrl={URL_PROTOCAL + REQUEST_HOSTNAME + REQUEST_URL}
                                        shareText={articleData?.title}
                                        showFacebook={true}
                                        showTwitter={true}
                                        showLinkedin={true}
                                        showWhatsapp={true}
                                        showPintrest={true} />
                                </div>
                                <div className="card-box img-box">
                                    {/* {heroImageData && heroImageData.imageSize && <img className="main-img" src={heroImageData?.imageUrl} alt={heroImageData?.alt} width="616" height="462" />} */}
                                    {heroImageData && heroImageData.imageSize &&
                                        (<picture>
                                            {/* Add multiple source elements for different image sources */}
                                            <source media="(min-width: 768px)" srcSet={getImageUrl(heroImageData.msid, heroImageData.imageSize, 760, 428, articleData.baseDomain, false, props.CONSTANTS, imagecroptype)} />
                                            <source media="(max-width: 767px)" srcSet={getImageUrl(heroImageData.msid, heroImageData.imageSize, 328, 185, articleData.baseDomain, false, props.CONSTANTS, imagecroptype)} />
                                            {/* Fallback image for browsers that do not support the picture element */}
                                            {showViewport ? (<img alt={heroImageData.alt} title={heroImageData.alt} loading="lazy" />)
                                                : (<img alt={heroImageData.alt} title={heroImageData.alt} loading="lazy" />)}
                                        </picture>)
                                    }
                                </div>

                                {showImageCredits && heroImageData && heroImageData.imageSize &&
                                    <div className='commonImagecreditMainWrapper'>
                                        {/* <div className='commonImageCeditTitle'> {heroImageData.imageMetaTitle}</div> */}
                                        <div className='commonImageCeditAgencyAuth'> {getImageCreditString(heroImageData.imageMetaAgency, heroImageData.imageMetaAuthor, heroImageData.imageSourceName, allData?.it?.pubInfo?.channel)} </div>
                                    </div>
                                }
                                <div className="card-box synopsis">{articleData ? articleData?.synopsis : ''}</div>
                                <div className='themeTwoArticalShowSnopsisWrap'>
                                    {articleData?.summary && <div className='themeTwoArticalShowSnopsis' dangerouslySetInnerHTML={{ __html: articleData?.summary || '' }} />}

                                </div>

                                <div className='themeTwoArticalShowContentWrap'>
                                    <div className='themeTwoArticalShowSocialWrap articalShowDesktopSocial'>
                                        <SocialShareTwo
                                            shareUrl={URL_PROTOCAL + REQUEST_HOSTNAME + REQUEST_URL}
                                            shareText={articleData?.title}
                                            showFacebook={true}
                                            showTwitter={true}
                                            showLinkedin={true}
                                            showWhatsapp={true}
                                            showPintrest={true} />
                                    </div>
                                    <div className='themeTwoArticalShowSummeryWrap'>

                                        {articleData.highlights && (
                                            <div className='ShowHeighlightTextWrapper'>
                                                <div className='ShowHeighlightHeading'>Highlights</div>
                                                <div>{articleData?.highlights}</div>
                                                {/* <div className='liveBlogBigSynopsis'>{parse(articleData?.highlights)}</div> */}
                                            </div>
                                        )}
                                        
                                        <Typography component="div">
                                            {completeBody && processArticleBody_New(completeBody.articleBody, completeBody.cmsembeds, completeBody.baseDomain, completeBody.CONSTANTS, completeBody.bodySnippet, completeBody.adSize, props.clientHostId, allData?.it?.pubInfo.channel, showImageCredits, completeBody.relatedStories, showRelatedStories, starKeyword, relatedStoriesLable)}
                                        </Typography>
                                    </div>

                                </div>

                                <Grid container direction="row">
                                    <Grid item sm={12}>
                                        {props.showTags && <Tag baseDomain={allData?.it?.pubInfo.baseDomain} tagsData={tagsData} anchorLinksValue={anchorLinksValue} />}
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </CacheProvider>
        );
    }
    return (
        <CacheProvider value={getMUICache()}>
            {getRenderPart()}
            {authorCard && articleData.authorDetails && Array.isArray(articleData.authorDetails) && articleData.authorDetails.length >= 0 &&
                articleData.authorDetails.map((authorDetail: any) => (
                    getAuthorCardTwo(props, authorDetail)
                ))}
        </CacheProvider>
    )
}
